import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.modal.commission_consent.title',
        defaultMessage: 'Introducer Commission'
    },
    subtitle: {
        id: '_.modal.commission_consent.subtitle',
        defaultMessage:
            'iwoca will pay {commission_amount} ({commission_rate} of {cash_amount}) to {introducer_name} as commission for this funding.'
    },
    extraCommissionSection: {
        id: '_.modal.commission_consent.extra_subtitle',
        defaultMessage:
            'iwoca may also pay {introducer_name} an additional commission based on the total value of loans they introduce to us over time. This additional commission generally makes up no more than {extra_commission_percentage} of the total drawn amount. We set additional commissions independently of setting the interest or fees on your loan with us.'
    },
    revenueCommissionSection: {
        id: '_.modal.commission_consent.revenue_subtitle',
        defaultMessage:
            "When you make repayments to iwoca on this loan, we'll share up to {extra_commission_percentage} of the interest and/or fees (not loan principal) with {introducer_name} as a commission. The exact percentage will be determined by the total value of loans {introducer_name} introduces to us over time. We set commissions independently of setting the interest or fees on your loan with us."
    },
    checkboxLabel: {
        id: '_.modal.commission_consent.checkbox_label',
        defaultMessage: 'I acknowledge that iwoca will pay this commission'
    },
    confirmAction: {
        id: '_.modal.commission_consent.confirm_action',
        defaultMessage: 'Confirm'
    }
});
